import { render } from "./TransactionView.vue?vue&type=template&id=6a92d6ee&ts=true"
import script from "./TransactionView.vue?vue&type=script&lang=ts"
export * from "./TransactionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__